export default "__VITE_ASSET__qCgqaX4q__"